import { render, staticRenderFns } from "./ListDots.vue?vue&type=template&id=1e3cd576&"
import script from "./ListDots.vue?vue&type=script&lang=js&"
export * from "./ListDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports